var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5346 15.6643C17.3236 15.6643 21.3378 12.2377 21.9013 7.76221H3.16792C3.73132 12.2377 7.74561 15.6643 12.5346 15.6643Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 6.71329C25 4.26573 24.2253 1.88811 22.9576 0H20.6336C22.183 1.81818 23.0985 4.1958 23.0985 6.71329C23.0985 7.13287 23.0985 7.55245 23.0281 7.97203C22.4647 12.9371 18.3095 16.9231 13.2388 17.2727H11.7599C6.68922 16.9231 2.53408 13.007 1.97067 7.97203C1.90025 7.55245 1.90025 7.13287 1.90025 6.71329C1.9015 4.12587 2.81704 1.81818 4.36642 0H2.04236C0.774687 1.95804 0 4.26573 0 6.71329C0 13.2168 5.07068 18.5315 11.409 19.021V26.7133C8.23985 26.993 5.70451 28.3217 5.35238 30H19.508C19.1559 28.3217 16.6206 26.9231 13.4514 26.7133V19.021C19.9306 18.4615 25.0013 13.1469 25.0013 6.71329H25Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass);
export default __webpack_public_path__ + "static/media/glass.9c665f3507eaf8662e3de51b2e3ae160.svg";
export { ForwardRef as ReactComponent };